export default {
  site_name: "黄瓜影视在线看",
  site_slogan: "免费高清影视全集",
  nav_home: "首页",
  nav_category: "分类",
  nav_about: "关于我们",
  category_movie: "电影",
  category_tv: "电视剧",
  category_variety: "综艺",
  category_anime: "动漫",
  hero_title: "热门推荐",
  hero_subtitle: "海量高清影视资源免费畅享",
  hot_recommend: "热门推荐",
  latest_update: "最新更新",
  view_detail: "查看详情",
  play_now: "立即播放",
  loading: "加载中...",
  no_data: "暂无数据",
  back_to_home: "返回首页",
  all_categories: "全部分类",
  search_placeholder: "搜索你想看的影视...",
  footer_copyright: "© 2024 黄瓜影视在线看 版权所有",
  footer_desc: "黄瓜影视在线看，海量高清影视资源免费畅享，涵盖热门电影、电视剧、综艺、动漫等全类型内容。",
  about_title: "关于我们",
  about_brand: "品牌介绍",
  about_reputation: "口碑评价",
  about_contact: "联系我们",
  contact_address: "公司地址",
  contact_email: "电子邮箱",
  contact_phone: "联系电话",
  read_more: "查看更多",
  back_to_top: "回到顶部",
  breadcrumb_home: "首页",
  article_director: "导演",
  article_cast: "主演",
  article_genre: "类型",
  article_year: "年份",
  article_region: "地区",
  article_rating: "评分",
  article_description: "剧情简介",
  related_recommend: "相关推荐",
};